import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-home",
    imports: [],
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"]
})
export class HomeComponent implements OnInit {
    title = "{{Home | transloco}}";

    ngOnInit(): void {}
}
